import { typographyStyles } from "@newsela/angelou";
const { heading4Obj } = typographyStyles;

export const titleCss = { width: "max-content", ...heading4Obj };

export const drawerContainerCss = {
  padding: "1em",
  borderTop: "none",
};
